import type { FC } from 'react'
import React, { memo, useState, useEffect } from 'react'
import { ResponsivePie } from '@nivo/pie'
import ChartTooltip from '../ChartTooltip'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import ChartLegend from '../ChartLegend'
import NoData from '../NoData'
import { isEqual } from '@homeviews/utils'

interface IProps {
  data: any
  gridRef?: HTMLElement
  chartType: 'reviewerAges' | 'default'
}

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      // display: 'flex',
      // marginTop: 50
      // '& .l-chartLegend': {
      //   flexDirection: 'column',
      //   marginTop: 0
      // },
      // '& .l-chartWrapper': {
      //   flex: 1,
      //   width: 'auto'
      // }
    },
    legendWrapper: {
      //
    },
  }),
)

const DonutChart: FC<IProps> = memo(
  ({ data, gridRef, chartType }) => {
    const classes = useStyles()
    const [disabledDatasets, setDisableDatasets] = useState<string[]>([])
    const [filteredData, setFilteredData] = useState<any>(data)

    useEffect(() => {
      if (!filteredData) {
        return
      }

      let newFilteredData = [...data]

      newFilteredData = newFilteredData.filter((item: any) => {
        if (
          disabledDatasets.find(
            (filterValue: string) => filterValue === item?.id,
          )
        ) {
          return false
        }
        return true
      })

      setFilteredData(newFilteredData)
    }, [disabledDatasets, data])

    const handleChartLegendClick = (id: string) => {
      let newDatasets = [...disabledDatasets]

      if (newDatasets.find((itemId: any) => itemId === id)) {
        newDatasets = newDatasets.filter((itemId: any) => itemId !== id)
      } else {
        newDatasets.push(id)
      }
      setDisableDatasets(newDatasets)
    }

    if (!data || !data?.length) {
      if (gridRef) {
        gridRef.style.display = 'none'
        return <NoData />
      }
    } else {
      if (gridRef) {
        gridRef.style.display = 'block'
      }
    }

    return (
      <div className={clsx('.l-chartContainer', classes.root)}>
        <div className="l-chartWrapper">
          <ResponsivePie
            data={filteredData}
            innerRadius={0.7}
            padAngle={0.7}
            animate={false}
            // motionConfig="slow"
            transitionMode="startAngle"
            colors={{ datum: 'data.color' }}
            tooltip={(tooltip: any) => {
              let tooltipText = `${tooltip.datum?.data?.label}: ${tooltip.datum?.data?.value}`

              if (chartType === 'reviewerAges') {
                tooltipText = `${tooltip.datum?.data?.value} reviews (Age Range: ${tooltip.datum?.data?.label})`
              }
              return (
                <ChartTooltip>
                  <ChartLegend
                    direction="vertical"
                    data={[
                      {
                        text: tooltipText,
                        shapeColor: tooltip.datum?.color,
                      },
                    ]}
                  />
                </ChartTooltip>
              )
            }}
            enableArcLinkLabels={false}
            enableArcLabels={false}
          />
        </div>
        <div className={classes.legendWrapper}>
          <ChartLegend
            data={data.map((item) => ({
              id: item.id,
              text: item.label,
              shapeColor: item.color,
              disabled: !!disabledDatasets.find(
                (datasetItem: any) => datasetItem === item.id,
              ),
            }))}
            disabledDatasets={disabledDatasets}
            onClick={handleChartLegendClick}
          />
        </div>
      </div>
    )
  },
  (prevProps, nextProps) => isEqual(prevProps, nextProps),
)

export default DonutChart
